import { render, staticRenderFns } from "./FilterSemaforoFaltantes.vue?vue&type=template&id=b6ddcf5a&scoped=true&"
import script from "./FilterSemaforoFaltantes.vue?vue&type=script&lang=js&"
export * from "./FilterSemaforoFaltantes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ddcf5a",
  null
  
)

export default component.exports